import { render, staticRenderFns } from "./GraficaCompras.vue?vue&type=template&id=1cf10696"
import script from "./GraficaCompras.vue?vue&type=script&lang=js"
export * from "./GraficaCompras.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports